var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{staticClass:"top-nav-breadcrumb"},[_vm._l((_vm.$store.getters.bread),function(item){return [_c('el-breadcrumb-item',{key:item.path,attrs:{"to":item.path}},[_vm._v(" "+_vm._s(item.title)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }